import $ from 'jquery'
import React from 'react'
import { Component } from 'react'

import Popup from "./Popup";
import Zitat from "../../../zitat_display/js/components/Zitat";


class ZitatPopup extends Component {
    state = {
        url: $("[data-zitat-url]").data("zitat-url"),
        data: null,
    };

    sendRequest = () => {
        let pks = this.props.pk;
        if (typeof pks !== "object")
            pks = [pks];

        this.setState({data: {}});

        for (const pk of pks) {
            $.ajax({
                url: this.state.url,
                method: "GET",
                dataType: "json",
                data: {
                    pk: pk,
                },
                success: (data) => {
                    this.setState((prevState, props) => ({
                        data: {
                            ...prevState.data,
                            [pk]: data
                        }
                    }));
                }
            });
        }
    };

    componentDidMount() {
        this.sendRequest();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.pk !== this.props.pk)
            this.sendRequest();
    }

    render() {
        const data = this.state.data;

        //if (data && data.pk !== this.props.pk)
        //    this.sendRequest();
        const zitatWidgets = [];
        if (data) {
            for (const pk in data) {
                zitatWidgets.push(
                    <Zitat key={pk} {...data[pk]}
                        onChangeZitat={this.props.onChangeZitat}
                    />
                );
            }
        }

        return (
            <Popup onClose={this.props.onClose} onChangeZitat={this.props.onChangeZitat}>
                {zitatWidgets}
            </Popup>
        );
    }
}

export default ZitatPopup


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/ZitatPopup.js